export function calculateProgressionPercentage(start: number | null, end: number) {
  if (!start) {
    return null;
  }
  if (start === end) {
    return 0;
  }

  const range = end - start;
  const percentage = (range / Math.abs(start)) * 100;
  return percentage;
}
